import React from "react";

import { Typography } from "@material-ui/core";
import useStyles from "./styles";

const FormLabel = ({ label, required }) => {
  const classes = useStyles();
  return (
    <Typography variant="body2" className={classes.label} noWrap>
      {label}
      {required && (
        <Typography
          variant="body2"
          component="strong"
          className={classes.required}
        >
          *
        </Typography>
      )}
    </Typography>
  );
};

export default FormLabel;
